import { computed } from "@preact/signals-react"

import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'

const CloneProfileModal = function ({ showSignal, cloneProfileItemSignal, newProfileNameSignal, nameAlreadyUsedComputed, handleSubmit }) {

    const handleCloseModal = () => {
        showSignal.value = false
    }

    const disableCloneSubmitSignal = computed(
        () => {
            return (newProfileNameSignal.value.length == 0 || nameAlreadyUsedComputed.value)
        }
    )

    return (
        <Modal show={showSignal.value} onHide={handleCloseModal}>
            <Modal.Header closeButton>
                <Modal.Title>Clone Profile {cloneProfileItemSignal.value.name}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Enter the name of the new profile below. This profile will carry over all the configuration settings from {cloneProfileItemSignal.value.name}</p>
                <Form>
                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                        <Form.Label>Profile Name</Form.Label>
                        <Form.Control
                            type="text"
                            required
                            onInput={(e) => newProfileNameSignal.value = e.target.value}
                            autoFocus
                            value={newProfileNameSignal.value}
                        />
                        <p className="mt-1" hidden={!nameAlreadyUsedComputed.value}>Profile name must be unique</p>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={handleCloseModal}>
                    Cancel
                </Button>
                <Button disabled={disableCloneSubmitSignal.value} variant="primary" onClick={handleSubmit}>
                    Clone
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
export default CloneProfileModal